import { googleEventToRdv, rdvToGoogleEvent } from '../utils'
import moment from 'moment'
import { mapState } from 'vuex'
import { bus, EVENTS } from '../services/bus/index.js'

export default {
  data () {
    return {
      loadingMaps: false
    }
  },
  computed: {
    ...mapState(['gApiReady', 'googleLogged', 'googleCalendars', 'currentUser'])
  },
  methods: {
    checkGoogle (event) {
      if (!this.gApiReady) return
      if (!this.googleLogged) {
        window.gapi.auth2.getAuthInstance().signIn().then(() => {
          this.googleExport(event)
        })
      }
      if (this.gApiReady && this.googleLogged) {
        this.googleExport(event)
      }
    },
    googleExport (event) {
      let params = {
        event: Object.assign({}, event)
      }
      this.$store.commit('setQuickview', {mode: 'GOOGLE_EXPORT', params})
    },
    openGoogleExport (event) {
      let params = {
        event: Object.assign({}, event)
      }
      if (!this.gApiReady || !this.googleLogged) {
        this.makeGoogleLogin(() => {
          this.$store.commit('setQuickview', {mode: 'GOOGLE_EXPORT', params})
        })
      } else {
        this.$store.commit('setQuickview', {mode: 'GOOGLE_EXPORT', params})
      }
      this.mode = null
    },
    makeGoogleLogin (cb = null) {
      if (this.googleLogged) return
      window.gapi.auth2.getAuthInstance().signIn().then(res => {
        console.log('connexion ok')
        if (cb && typeof cb === 'function') cb()
      })
    },
    googleSync (event) {
      let request = window.gapi.client.calendar.events.get({
        eventId: event.google_event_id,
        calendarId: event.google_calendar_id
      })
      request.execute((e) => {
        // else if ('code' in e && (e.code === 404 || e.code === 401 || e.code === 403)) {
        //   setTimeout(() => {
        //     let monText = 'Rendez vous ' + event.rdv_type + ' avec ' + event.contact_name + ' synchronisation impossible'
        //     this.$notify({
        //       type: 'is-danger-exclamation',
        //       text: monText
        //     })
        //   }, 1000)
        // }
        if ('code' in e && e.code === 400) {
          console.log('error google sync')
        } else {
          if (e.status === 'cancelled') {
            console.log('removed rdv')
            this.removeRdv(event)
          } else {
            // let dateEvent = moment.utc(event.google_last_sync)
            // let delta = moment.utc().diff(dateEvent, 'minutes')
            console.log('updateRdv')
            let data = googleEventToRdv(e)
            data = Object.assign({}, event, data)
            data.google_last_sync = new Date()
            this.updateRdv(data, true)
          }
        }
      })
    },
    removeRdv (event) {
      console.log('remove in Google -> remove in CRM ')
      this.$api.rdvService.delete(event.pk)
    },
    deleteSynchroGoogle (event) {
      event.google_calendar_id = null
      event.google_event_id = null
      console.log(event)
      this.$api.rdvService.put(event.pk, event).then(() => {
        console.log('delete synchro google -> done')
      })
    },
    patchRdvInGoogle (event, data) {
      window.gapi.client.calendar.events.patch({
        eventId: event.google_event_id,
        calendarId: event.google_calendar_id,
        ...data
      }).execute((e) => {
        if ('code' in e && e.code === 400) {
          console.log('error patch google')
          this.$notify({
            type: 'is-warning',
            text: 'Erreur synchronisation Google, vos modifications seront écrasées lors de la prochaine synchronisation. Veuillez vous rapprocher du créateur du rendez-vous.'
          })
        } else console.log('Patch google')
      })
    },
    removeRdvInGoogle (event) {
      console.log('remove in CRM -> remove in Google ')
      let request = window.gapi.client.calendar.events.delete({
        eventId: event.google_event_id,
        calendarId: event.google_calendar_id
      })
      request.execute((e) => {
        if ('code' in e && e.code === 400) {
          console.log(e)
          console.log('error google sync')
        } else {
          this.$notify({
            type: 'is-success',
            text: 'Rdv supprimé sur Google'
          })
        }
      })
    },
    createRdvInGoogle (event, calendar = null) {
      if (!calendar) bus.$emit(EVENTS.LOADING, true)
      if (this.calendar && !calendar) calendar = this.calendar
      let googleEvent = rdvToGoogleEvent(event, this.$configs.APPHOST)
      let request = window.gapi.client.calendar.events.insert({
        calendarId: calendar,
        resource: googleEvent
      })
      request.execute((e) => {
        if ('code' in e && e.code === 400) {
          console.log(e)
          this.$notify({
            type: 'is-danger',
            text: 'Impossible d\'exporter ce rendez-vous vers le compte Google.'
          })
        } else {
          this.$api.rdvService.patch(event.pk, {
            google_calendar_id: calendar,
            google_event_id: e.id,
            exported_by: this.currentUser.pk,
            exported_by_name: this.currentUser.last_name + ' ' + this.currentUser.first_name
          }).then(r => {
            this.$emit('submit', {})
            bus.$emit(EVENTS.LOADING)
            this.$notify({
              type: 'is-success',
              text: 'Rendez-vous exporté vers le compte Google.'
            })
          })
        }
      })
    },
    updateRdv (data, silent = false) {
      this.$api.rdvService.put(data.pk, data).then(r => {
        this.$emit('openEvent', null)
        this.$emit('newEvent', data, true)
        let rdv = r.data
        let key = moment(rdv.date).format('DD/MM/YYYY')
        this.$store.commit('addCalendarEvent', {event: rdv, key, type: 'rdvs'})
        if (!silent) {
          this.$notify({
            type: 'is-success',
            text: 'Rdv modifié.'
          })
        }
      })
    },
    getCurrentLocation () {
      this.loadingMaps = true
      if (localStorage.getItem('userAddress')) {
        this.openGoogleMaps(JSON.parse(localStorage.getItem('userAddress')), this.event.address)
      } else {
        if ('geolocation' in navigator) navigator.geolocation.getCurrentPosition(this.getGoogleMaps)
        else this.loadingMaps = false
      }
    },
    getGoogleMaps (position) {
      const geocoder = new window.google.maps.Geocoder()
      const place = {lat: parseFloat(position.coords.latitude), lng: parseFloat(position.coords.longitude)}
      geocoder.geocode({'location': place}, (results, status) => {
        this.loadingMaps = false
        if (status === 'OK') {
          this.openGoogleMaps(results[0].formatted_address, this.event.address)
          localStorage.setItem('userAddress', JSON.stringify(results[0].formatted_address))
        }
      })
      this.loadingMaps = false
    },
    openGoogleMaps (results, address) {
      this.loadingMaps = false
      const origin = results.split(' ').join('+')
      const destination = `${address.line1 || ''}+${address.zip_code}+${address.city}`
      window.open(`https://www.google.fr/maps/dir/${origin}/${destination}/`, '_blank')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/GoogleMixin.js